export const formatFileSize = (bytes: number): string => {
  if (bytes <= 0) return "0B";

  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(k)),
    sizes.length - 1
  );

  return `${Math.round(bytes / Math.pow(k, i))}${sizes[i]}`;
};
